// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as IndexRouteImport } from './pages/index'
import { Route as ChangelogRouteImport } from './pages/changelog'
import { Route as CreditsRouteImport } from './pages/credits'
import { Route as CustomizeExperienceRouteImport } from './pages/customize-experience'
import { Route as InspirationRouteImport } from './pages/inspiration'
import { Route as McpRouteImport } from './pages/mcp'
import { Route as ProjectsRouteImport } from './pages/projects'
import { Route as SettingsRouteImport } from './pages/settings'
import { Route as SpecialOfferRouteImport } from './pages/special-offer'
import { Route as TeamRouteImport } from './pages/team'
import { Route as UpgradeToTeamRouteImport } from './pages/upgrade-to-team'
import { Route as WhatsNewRouteImport } from './pages/whats-new'
import { Route as AdminTasteRouteImport } from './pages/admin/taste'
import { Route as AuthResetRouteImport } from './pages/auth/reset'
import { Route as AuthSigninRouteImport } from './pages/auth/signin'
import { Route as AuthSignupRouteImport } from './pages/auth/signup'
import { Route as FlowIndexRouteImport } from './pages/flow/index'
import { Route as FlowIdRouteImport } from './pages/flow/$id'
import { Route as PreviewIndexRouteImport } from './pages/preview/index'
import { Route as PreviewIdRouteImport } from './pages/preview/$id'
import { Route as PrototypeIndexRouteImport } from './pages/prototype/index'
import { Route as PrototypeIdRouteImport } from './pages/prototype/$id'
import { Route as SubscriptionIndexRouteImport } from './pages/subscription/index'
import { Route as SubscriptionSuccessRouteImport } from './pages/subscription/success'
import { Route as TutorialsIndexRouteImport } from './pages/tutorials/index'
import { Route as TutorialsIdRouteImport } from './pages/tutorials/$id'
import { Route as FlowIdEditRouteImport } from './pages/flow/$id_.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const CreditsRoute = CreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => rootRouteImport
          })
const CustomizeExperienceRoute = CustomizeExperienceRouteImport.update({
            id: '/customize-experience',path: '/customize-experience',getParentRoute: () => rootRouteImport
          })
const InspirationRoute = InspirationRouteImport.update({
            id: '/inspiration',path: '/inspiration',getParentRoute: () => rootRouteImport
          })
const McpRoute = McpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SpecialOfferRoute = SpecialOfferRouteImport.update({
            id: '/special-offer',path: '/special-offer',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const UpgradeToTeamRoute = UpgradeToTeamRouteImport.update({
            id: '/upgrade-to-team',path: '/upgrade-to-team',getParentRoute: () => rootRouteImport
          })
const WhatsNewRoute = WhatsNewRouteImport.update({
            id: '/whats-new',path: '/whats-new',getParentRoute: () => rootRouteImport
          })
const AdminTasteRoute = AdminTasteRouteImport.update({
            id: '/admin/taste',path: '/admin/taste',getParentRoute: () => rootRouteImport
          })
const AuthResetRoute = AuthResetRouteImport.update({
            id: '/auth/reset',path: '/auth/reset',getParentRoute: () => rootRouteImport
          })
const AuthSigninRoute = AuthSigninRouteImport.update({
            id: '/auth/signin',path: '/auth/signin',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const FlowIndexRoute = FlowIndexRouteImport.update({
            id: '/flow/',path: '/flow/',getParentRoute: () => rootRouteImport
          })
const FlowIdRoute = FlowIdRouteImport.update({
            id: '/flow/$id',path: '/flow/$id',getParentRoute: () => rootRouteImport
          })
const PreviewIndexRoute = PreviewIndexRouteImport.update({
            id: '/preview/',path: '/preview/',getParentRoute: () => rootRouteImport
          })
const PreviewIdRoute = PreviewIdRouteImport.update({
            id: '/preview/$id',path: '/preview/$id',getParentRoute: () => rootRouteImport
          })
const PrototypeIndexRoute = PrototypeIndexRouteImport.update({
            id: '/prototype/',path: '/prototype/',getParentRoute: () => rootRouteImport
          })
const PrototypeIdRoute = PrototypeIdRouteImport.update({
            id: '/prototype/$id',path: '/prototype/$id',getParentRoute: () => rootRouteImport
          })
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
            id: '/subscription/',path: '/subscription/',getParentRoute: () => rootRouteImport
          })
const SubscriptionSuccessRoute = SubscriptionSuccessRouteImport.update({
            id: '/subscription/success',path: '/subscription/success',getParentRoute: () => rootRouteImport
          })
const TutorialsIndexRoute = TutorialsIndexRouteImport.update({
            id: '/tutorials/',path: '/tutorials/',getParentRoute: () => rootRouteImport
          })
const TutorialsIdRoute = TutorialsIdRouteImport.update({
            id: '/tutorials/$id',path: '/tutorials/$id',getParentRoute: () => rootRouteImport
          })
const FlowIdEditRoute = FlowIdEditRouteImport.update({
            id: '/flow/$id_/edit',path: '/flow/$id/edit',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ChangelogRoute: ChangelogRoute,CreditsRoute: CreditsRoute,CustomizeExperienceRoute: CustomizeExperienceRoute,InspirationRoute: InspirationRoute,McpRoute: McpRoute,ProjectsRoute: ProjectsRoute,SettingsRoute: SettingsRoute,SpecialOfferRoute: SpecialOfferRoute,TeamRoute: TeamRoute,UpgradeToTeamRoute: UpgradeToTeamRoute,WhatsNewRoute: WhatsNewRoute,AdminTasteRoute: AdminTasteRoute,AuthResetRoute: AuthResetRoute,AuthSigninRoute: AuthSigninRoute,AuthSignupRoute: AuthSignupRoute,FlowIdRoute: FlowIdRoute,PreviewIdRoute: PreviewIdRoute,PrototypeIdRoute: PrototypeIdRoute,SubscriptionSuccessRoute: SubscriptionSuccessRoute,TutorialsIdRoute: TutorialsIdRoute,FlowIndexRoute: FlowIndexRoute,PreviewIndexRoute: PreviewIndexRoute,PrototypeIndexRoute: PrototypeIndexRoute,SubscriptionIndexRoute: SubscriptionIndexRoute,TutorialsIndexRoute: TutorialsIndexRoute,FlowIdEditRoute: FlowIdEditRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)